import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import Login from "../ui/login";
import { useQueryString } from "../hooks/use-query-string";
import { LoadingContainer } from "./loading-container";
import { fetchAppConfig } from "../hooks/use-config";

export default function Home() {
    const query = useQueryString();
    const [redirect, setRedirect] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [redirectUrl, setRedirectUrl] = useState<string>("/app/dashboard");

    useEffect(() => {
        const getConfig = async () => {
            setLoading(true);
            const data = await fetchAppConfig();
            setLoading(false);

            if (data?.nav_menu) {
                setRedirectUrl(data?.nav_menu[0]?.url || "/app");
            }
            setRedirect(true);
        };

        const token = localStorage.getItem("token");
        if (token) {
            void getConfig();
        }
    }, []);

    if (loading) {
        return <LoadingContainer />;
    }

    if (redirect) {
        return <Navigate to={redirectUrl} replace />;
    }

    return <Login redirectUrl={query.get("redirectUrl") || undefined} />;
}
